export const currencyValue = {
  IDR: 'Rp',
}

export const thousandSeparator = value => {
  if (value === null || value === undefined) return value

  const [integer, decimal] = value.toString().split('.')

  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return decimal ? `${formattedInteger},${decimal}` : formattedInteger
}

export const currencyConverter = (value, currency_type) => {
  return currencyValue[currency_type]
    ? `${currencyValue[currency_type]} ${thousandSeparator(value)}`
    : value
}

export const currencyConverterDecimal = (value, currency = 'IDR') => {
  if (value === null || value === undefined || value === '') return ''

  const formattedValue = parseFloat(value).toFixed(2)
  const [integerPart, decimalPart] = formattedValue.split('.')
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const currencyPrefix = currency === 'IDR' ? 'Rp. ' : ''
  return `${currencyPrefix}${formattedInteger},${decimalPart}`
}
